import React from 'react';

const ModuleFederationPlugin = React.lazy(() => import('moduleFederationExample/ModuleFederationExample'));

export const ModuleFederationPluginContainer: React.FC = () => <ModuleFederationPlugin />;
